module.exports = __webpack_public_path__ + "img/clip.7e38d69a.svg";